// `/app/developers/docs` (`spec/17-frontend.md` §8.1, croqui
// `screens/seller/documentacao.tsx`). Tela estática: `GET /v1/docs` e
// `GET /v1/openapi.json` são links externos, não chamadas do painel.

import { createFileRoute } from '@tanstack/react-router';
import { DocsScreen } from '../features/events/docs-screen.tsx';

export const Route = createFileRoute('/app/developers/docs/')({ component: DocsScreen });
